import React, { Component } from "react";
import {
  Modal,
  Button,
  ModalHeader,
  ModalBody,
  InputGroup,
  Row,
  Col,
} from "reactstrap";
import Draggable from "react-draggable";

import { FetchData } from "./utils/DataFetch";
import { GetCookie } from "./utils/Common";

import { ClaimantForm } from "./ClaimantForm";
import { ClaimantFormSearchTableDefault } from "./ClaimantFormSearchTableDefault";

import AddIcon from "../images/add.png";

export class ClaimantFormSearch extends Component {
  static displayName = ClaimantFormSearch.name;

  constructor(props) {
    super(props);

    this.user = JSON.parse(GetCookie("user"));
    this.state = {
      claimantList: [],

      alert: props.alert,

      deltaPosition: { x: 0, y: 0 },
      modalClaimantForm: false,
      model: this.getInitialModel(),
      searchModel: {
        ClmId: "",
        ClmClaimNumberNoDash: "",
        Name: this.props.Name,
        ClientAbbrv: "",
        ClientId:
          props.workorder.ClientId === null ||
          props.workorder.ClientId === undefined
            ? ""
            : props.workorder.ClientId,
      },

    };

    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.handleChange = this.handleChange.bind(this);

    if (props.Name !== null && props.Name !== "") this.populateClaimantData();

    this.setModalClaimantForm = this.setModalClaimantForm.bind(this);
    this.handleClaimantSaveEventSuccess =
      this.handleClaimantSaveEventSuccess.bind(this);

      this.clmSearchRef = React.createRef();
  }

  componentDidMount() {
    this.setState({ isMounted: true }); // Set isMounted to true when the component mounts

    document.addEventListener('keydown', this.keydownHandler);

    // Set focus to the rep name field
    setTimeout(() => {
      if (this.clmSearchRef.current) {
        this.clmSearchRef.current.focus();
      }
    }, 100);

    return () => {
      document.removeEventListener('keydown', this.keydownHandler);
    };
  }

  onStart = () => {};

  onStop = () => {};

  handleDrag = (e, ui) => {
    const { deltaPosition } = this.state;
    this.setState({
      deltaPosition: {
        x: deltaPosition.x + ui.deltaX,
        y: deltaPosition.y + ui.deltaY,
      },
    });
  };

  getInitialModel(overrides = {}) {
    const workorder = this.props.workorder || {};
    const baseModel = {
      EventType: "insert",
      ClmId: null,
      RepId: workorder.RepId,
      ClmLastName: "",
      ClmFirstName: "",
      ClmClaimNumber: "",
      ClmClaimNumberNoDash: "",
      ClmPhone: "",
      ClmInvoiceType: "",
      ClmInvoiceCaption: "",
      ClmLanguage: "",
      ClmNote: "",
      ClmWCABNumber: "",
      ClmInsuredParty: "",
      ClmEmployer: "",
      ClmDateOfInjuryStart: "",
      ClmDateOfInjuryEnd: "",
      ClmDateOfInjury: "",
      ClmDateofInjuryStart: null,
      ClmDateofInjuryEnd: null,
      ClmDateOfLoss: "",
      ClmStreet: "",
      ClmCity: "",
      ClmState: "",
      ClmZip: "",
      ClmEmail: "",
      ClmSSN: "",
      ClmDOB: null,
      ClmDiagnosis: "",
      ClmGender: "",
      ClmAppAtty: "",
      ClmAppAttyFirm: "",
      ClmAppAttyEmail: "",
      ClmAppAttyPhone: "",
      ClmDefAtty: "",
      ClmDefAttyFirm: "",
      ClmDefAttyEmail: "",
      ClmDefAttyPhone: "",
      ClmOrderedByName: "",
      ClmHeight: "",
      ClmWeight: "",
      CreateDateTime: null,
      CreatebyUserId: null,
      UpdateByUserId: null,
      UpdateDateTime: null,
      IsDeletedFlg: false,
      ClientId: workorder.ClientId,
      ClientName: workorder.ClientName,
      ClientAbbrv: workorder.ClientAbbrv,
      RepFirstName: "",
      RepLastName: "",
    };

    return { ...baseModel, ...overrides };
  }

  setModalClaimantForm() {
    this.setState((prevState) => {
      const nextModalState = !prevState.modalClaimantForm;
      if (nextModalState) {
        const claimNumberInput =
          prevState.searchModel?.ClmClaimNumberNoDash ?? "";
        const trimmedClaimNumber =
          typeof claimNumberInput === "string"
            ? claimNumberInput.trim()
            : "";
        const hasSearchResults =
          Array.isArray(prevState.claimantList) &&
          prevState.claimantList.length > 0;
        const overrides =
          trimmedClaimNumber.length > 0 && !hasSearchResults
            ? {
                ClmClaimNumber: trimmedClaimNumber,
                ClmClaimNumberNoDash: trimmedClaimNumber,
              }
            : {};

        return {
          modalClaimantForm: nextModalState,
          model: this.getInitialModel(overrides),
        };
      }

      return { modalClaimantForm: nextModalState };
    });
  }

  handleClaimantSaveEventSuccess(alert) {
    this.setState(
      {
        modalClaimantForm: alert.modal,
      },
      () => {
        this.populateClaimantDataOnSave();
      }
    );
  }

  handleChange(e) {
    let model = { ...this.state.searchModel };
    model[e.target.name] = e.target.value;

    this.setState({ searchModel: model });
  }

  handleKeyDown(e) {
    if (e.key === "Enter") {
      this.populateClaimantData();
    }
  }

  async populateClaimantData() {
    await FetchData(
      "/getclaimants",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      this.setState({ claimantList: data, loading: false });
    });
  }

  async populateClaimantDataOnSave() {
    await FetchData(
      "/getclaimants",
      "POST",
      this.user.token,
      this.state.searchModel
    ).then((data) => {
      if (data.length > 0) {
        var topData = [];
        topData.push(data[0]);
        this.setState({ claimantList: topData, loading: false });
      } else this.setState({ claimantList: data, loading: false });
    });
  }

  renderClaimantTable(claimantList) {
    return (
      <ClaimantFormSearchTableDefault
        claimantList={claimantList}
        handleDoubleClick={this.props.handleDoubleClick}
      ></ClaimantFormSearchTableDefault>
    );
  }

  render() {
    const dragHandlers = { onStart: this.onStart, onStop: this.onStop };
    const { deltaPosition = { x: 0, y: 0 } } = this.state || {};

    return (
      <Draggable
        handle=".claimant-form-search-handle"
        onDrag={this.handleDrag}
        {...dragHandlers}
      >
        <div style={{ height: "400px" }}>
          <Modal
            isOpen={this.props.modal}
            toggle={this.props.setModal}
            style={{
              transform: `translate(${deltaPosition.x}px, ${deltaPosition.y}px)`,
              width: "800px",
            }}
            backdrop="static"
          >
            <ModalHeader className="claimant-form-search-handle handle">
              <span style={{ fontSize: "14px" }}>Search Claimant</span>
            </ModalHeader>
            <ModalBody>
              <div>
                <Row>
                  <Col>
                    <InputGroup size="sm">
                      <input
                        name="ClmClaimNumberNoDash"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ClmClaimNumberNoDash}
                        onChange={this.handleChange}
                        placeholder="Claim #"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="Name"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.Name}
                        onChange={this.handleChange}
                        ref={this.clmSearchRef}
                        placeholder="Claimant (Lastname, Firstname)"
                        onKeyDown={this.handleKeyDown}
                      />
                      <input
                        name="ClientAbbrv"
                        type="text"
                        className="form-control form-control-text"
                        value={this.state.searchModel.ClientAbbrv}
                        onChange={this.handleChange}
                        placeholder="Client Abbrv"
                        onKeyDown={this.handleKeyDown}
                      />
                      <Button
                        color="btn"
                        size="sm"
                        onClick={this.setModalClaimantForm}
                      >
                        <img
                          src={AddIcon}
                          style={{ width: "16px", height: "16px" }}
                          alt="Add"
                        />{" "}
                        New
                      </Button>
                    </InputGroup>
                  </Col>
                </Row>
                <Row>
                  <Col>{this.renderClaimantTable(this.state.claimantList)}</Col>
                </Row>
              </div>
            </ModalBody>
          </Modal>

          {this.state.modalClaimantForm && (
            <ClaimantForm
              model={this.state.model}
              modal={this.state.modalClaimantForm}
              alert={this.state.alert}
              setModal={this.setModalClaimantForm}
              handleSaveEventSuccess={this.handleClaimantSaveEventSuccess}
            />
          )}
        </div>
      </Draggable>
    );
  }
}
